import React from 'react';
import '../styles/StructuredEvaluation.css';

const StructuredEvaluationRenderer = ({ evaluationData }) => {
  if (!evaluationData) return null;
  
  const { skillsMatch, experienceAlignment, recommendations, overallScore, conclusion } = evaluationData;
  
  return (
    <div className="structured-evaluation">
      {/* <div className="evaluation-header">
        <h2>Resume Evaluation Results</h2>
        <div className="score-badge" style={{
          backgroundColor: overallScore >= 75 ? '#4CAF50' : 
                           overallScore >= 50 ? '#FFC107' : '#FF5252'
        }}>
          {overallScore}%
        </div>
      </div> */}
      
      {/* Skills Match Section */}
      <section className="evaluation-section">
        <h3>Skills Match Analysis</h3>
        
        <div className="subsection strengths">
          <h4>Strengths</h4>
          <ul>
            {skillsMatch?.strengths?.map((strength, index) => (
              <li key={`strength-${index}`}>{strength}</li>
            )) || (
              <li>No specific strengths identified</li>
            )}
          </ul>
        </div>
        
        <div className="subsection gaps">
          <h4>Skill Gaps</h4>
          <ul>
            {skillsMatch?.gaps?.map((gap, index) => (
              <li key={`gap-${index}`}>{gap}</li>
            )) || (
              <li>No specific gaps identified</li>
            )}
          </ul>
        </div>
      </section>
      
      {/* Experience Alignment Section */}
      <section className="evaluation-section">
        <h3>Experience Alignment</h3>
        
        <div className="subsection matching">
          <h4>Matching Experience</h4>
          <ul>
            {experienceAlignment?.matching?.map((match, index) => (
              <li key={`match-${index}`}>{match}</li>
            )) || (
              <li>No matching experience identified</li>
            )}
          </ul>
        </div>
        
        <div className="subsection non-matching">
          <h4>Missing Experience</h4>
          <ul>
            {experienceAlignment?.nonMatching?.map((nonMatch, index) => (
              <li key={`nonmatch-${index}`}>{nonMatch}</li>
            )) || (
              <li>No missing experience identified</li>
            )}
          </ul>
        </div>
      </section>
      
      {/* Recommendations Section */}
      <section className="evaluation-section">
        <h3>Recommendations</h3>
        
        <div className="subsection for-candidate">
          <h4>For the Candidate</h4>
          <ul>
            {recommendations?.forCandidate?.map((rec, index) => (
              <li key={`rec-candidate-${index}`}>{rec}</li>
            )) || (
              <li>No specific recommendations for candidate</li>
            )}
          </ul>
        </div>
        
        <div className="subsection for-employer">
          <h4>For the Employer</h4>
          <ul>
            {recommendations?.forEmployer?.map((rec, index) => (
              <li key={`rec-employer-${index}`}>{rec}</li>
            )) || (
              <li>No specific recommendations for employer</li>
            )}
          </ul>
        </div>
      </section>
      
      {/* Conclusion */}
      {conclusion && (
        <section className="evaluation-section conclusion">
          <h3>Conclusion</h3>
          <p>{conclusion}</p>
        </section>
      )}
      
      {/* Overall Score */}
      <div className="overall-score">
        <h3>Overall Alignment Score: {overallScore}%</h3>
        <div className="score-recommendation">
          {overallScore >= 75 ? (
            "Strong match - Candidate highly aligned with job requirements"
          ) : overallScore >= 50 ? (
            "Potential match - Consider additional assessment"
          ) : (
            "Low alignment - May not be suitable for this role"
          )}
        </div>
      </div>
    </div>
  );
};

export default StructuredEvaluationRenderer;